export default __webpack_public_path__ + "static/media/pay.3a2b2b2e.png";